namespace TabAurous.OMS {
    export interface CheckListRow {
        CheckListId?: number;
        CheckListTypeId?: number;
        CheckListType?: string;
        CheckListName?: string;
    }

    export namespace CheckListRow {
        export const idProperty = 'CheckListId';
        export const nameProperty = 'CheckListName';
        export const localTextPrefix = 'OMS.CheckList';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CheckListId = "CheckListId",
            CheckListTypeId = "CheckListTypeId",
            CheckListType = "CheckListType",
            CheckListName = "CheckListName"
        }
    }
}
